/* ============
 * Actions for the assessment module
 * ============
 *
 * The actions that are available on the
 * assessment module.
 */
// import Vue from 'vue';
import PatientAssessmentProxy from '@/proxies/PatientAssessmentProxy';
import types from './mutation-types';


export const getAssessments = ({
  commit
}, data) => {
  commit(types.FETCH_ASSESSMENTS);
  new PatientAssessmentProxy().getAssessments(data)
    .then(({ totalCount, patients }) => {
      commit(types.FETCH_ASSESSMENTS_SUCCESS, {
        totalCount,
        patients
      });
    }).catch((error) => {
      commit(types.FETCH_ASSESSMENTS_FAIL, error);
    });
};

export const getAssessmentSymptoms = ({commit}) => {
  commit(types.FETCH_ASSESSMENT_SYMPTOMS);
  new PatientAssessmentProxy().getAssessmentSymptoms().then((response) => {
    commit(types.FETCH_ASSESSMENT_SYMPTOMS_SUCCESS, response);
  }).catch((error) => {
    commit(types.FETCH_ASSESSMENT_SYMPTOMS_FAIL, error)
  });
};


export default {
  getAssessments,
  getAssessmentSymptoms
};
